import Swal from "sweetalert2";

desableGa();
detectedBrowser();
doIt();

function desableGa() {
    window.ga =
        window.ga ||
        function () {
            console.warn("ga() fue llamado pero no está definido.");
        };
}

function detectedBrowser() {
    console.log(navigator.userAgent);
    const ua = navigator.userAgent.toLowerCase();
    return (
        ua.includes("fbav") || ua.includes("fban") || ua.includes("instagram")
    );
}

function openInBrowser() {
    const url = window.location.href;
    window.open(url, "_blank");
}

function copyToClipboard() {
    navigator.clipboard.writeText(window.location.href).then(() => {
        Swal.fire("Copiado", "Enlace copiado al portapapeles", "success");
    });
}
    
function doIt() {
    if (detectedBrowser()) {
        Swal.fire({
            title: "Abre este sitio en tu navegador",
            html: "Estás usando el navegador interno de <b>Facebook</b> o <b>Instagram</b>.<br>Para una mejor experiencia, ábrelo en Chrome o Safari.",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Abrir en el navegador",
            cancelButtonText: "Cerrar",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                openInBrowser();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                copyToClipboard();
            }
        });
    } else {
    }
}
